import Vue from 'vue';
import {
    extend,
    ValidationObserver,
    setInteractionMode,
    ValidationProvider,
} from 'vee-validate';
import * as Rule from 'vee-validate/dist/rules';


setInteractionMode('eager');

extend('max', {
    ...Rule.max,
    params: ['length'],
    message: '{_field_} can only have {length} letters',
});
extend('email', {
    ...Rule.email,
    message: 'Email must be valid',
});
extend('required', {
    ...Rule.required,
    validate(value) {
        return {
            required: true,
            valid: [0, '', null, undefined].indexOf(value) === -1,
        };
    },
    message: '{_field_} cannot be empty',
    computesRequired: true,
});
extend('min_value', {
    ...Rule.required,
    message: '{_field_} must choose an option',
});
extend('numeric', {
    ...Rule.numeric,
    message: '{_field_} must be numeric',
});
extend('digits', {
    ...Rule.digits,
    message: '{_field_} must be a valid digit',
});
extend('length', {
    ...Rule.length,
    message: 'Invalid {_field_}',
});
extend('min', {
    ...Rule.min,
    message: 'Invalid {_field_}',
});
extend('integer', {
    ...Rule.integer,
    message: 'Invalid {_field_}',
});
extend('double', {
    ...Rule.double,
    message: 'Invalid {_field_}',
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
